import { Button, Container, Group, Stack, Text, Title } from "@mantine/core";
import { IconServerOff } from "@tabler/icons-react";

export function ErrorPage() {
  return (
    <Container size="xs" py={80}>
      <Stack align="center" gap="lg">
        <IconServerOff size={120} stroke={1} color="var(--mantine-color-dimmed)" aria-hidden="true" />
        <Title order={1} ta="center">
          Something went wrong
        </Title>
        <Text c="dimmed" ta="center" maw={400}>
          An unexpected error occurred. Please try again or go back to the feed.
        </Text>
        <Group>
          <Button size="md" onClick={() => window.location.reload()}>
            Try again
          </Button>
          <Button
            size="md"
            variant="light"
            component="a"
            href="/"
          >
            Back to Feed
          </Button>
        </Group>
      </Stack>
    </Container>
  );
}
